import { httpClient } from '@/services/http/httpClient'

type GetPortfolioProjectTagsParams = {
  projectId: string
}

type GetPortfolioProjectTagsResponse = {
  tags: {
    id: string
    name: string
    color: string
    textColor: string
  }[]
}

export async function getPortfolioProjectTags({
  projectId,
}: GetPortfolioProjectTagsParams) {
  const { data } = await httpClient.get<GetPortfolioProjectTagsResponse>(
    `/projects/portfolio-tags/project-tags/${projectId}`,
  )

  return data.tags
}
